import { ISubWindowFacade, SubWindowStatus } from '../../../infrastructure/sub-windows';
import { SubWindowState, SubWindowViewModel } from './sub-window.viewmodel';

class SubWindowFacade implements ISubWindowFacade {
    constructor(
        private readonly viewModel: SubWindowViewModel,
        private readonly uid: number,
        ) {

    }

    public close = () => {
        return this.viewModel.closeSubWindow();
    };

    public getStatus = () => {
        if (this.viewModel.isClosed()) {
            return SubWindowStatus.Closed;
        } else {
            return this.viewModel.stateFlag === SubWindowState.MINIMIZED ? SubWindowStatus.Minimized : SubWindowStatus.Maximized;
        }
    };

    public getUID = () => {
        return this.uid;
    };

    public maximize = () => {
        this.viewModel.changeState(SubWindowState.MAXIMIZED);
    };

    public expand = () => {
        this.viewModel.changeState(SubWindowState.EXPANDED);
    };

    public minimize = () => {
        this.viewModel.changeState(SubWindowState.MINIMIZED);
    };
}

export { SubWindowFacade };
